<template>
  <div
    v-ripple
    class="chat-channel"
    :class="{ 'chat-channel--active': active }"
    @click="setChannel"
  >
    <v-avatar
      class="chat-channel__avatar"
      :color="channel.projectName | avatarColor"
      size="32"
    >
      <img
        v-if="channel.thumbnail"
        :src="channel.thumbnail.url"
        alt="John"
      >
    </v-avatar>
    <div class="chat-channel__details">
      <div class="chat-channel__name">
        {{ channel.projectName }}
      </div>
      <div class="chat-channel__users">
        {{ getMembersCount }}
      </div>
    </div>
    <div
      v-if="channel.unreadMessages"
      class="chat-channel__messages"
    >
      {{ channel.unreadMessages }}
    </div>
  </div>
</template>

<script>
import utils from '@/helpers/utils';

export default {
  props: {
    channel: {
      type: Object,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getMembersCount() {
      return utils.getCounterWithSuffix(this.channel.usersCount,
        'członek', 'członków', 'członków');
    },
  },

  methods: {
    setChannel() {
      this.$emit('change', this.channel.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-channel {
  padding: 8px 16px;
  border-radius: 2px;
  cursor: pointer;
  display: flex;
  align-items: center;

  &--active {
    background: #F9F9F9;
  }

  &__avatar {
    margin-right: 16px;
  }

  &__details {
    width: calc(100% - 88px);
    margin-right: 16px;
  }

  &__name {
    font-size: 13px;
    font-weight: 500;
  }

  &__users {
    font-size: 10px;
  }

  &__messages {
    border-radius: 2px;
    min-width: 24px;
    height: 24px;
    background: $primary;
    text-align: center;
    color: white;
    font-weight: bold;
    font-size: 10px;
    line-height: 24px;
  }
}
</style>
